import logo from "./logo.svg";
import "./App.css";
import TBAM from "./TBAM";

function App() {
  return (
    <div className="App">
      <TBAM />
    </div>
  );
}

export default App;
